import {Directive, ElementRef, HostBinding, OnInit, Renderer2} from '@angular/core';
import {NgControl} from "@angular/forms";

@Directive({
  selector: '[vbClearInput]'
})
export class ClearInputDirective implements OnInit {

  @HostBinding('style.padding-right')
  padding: string = '25px';

  constructor(private el: ElementRef, private renderer: Renderer2, private control?: NgControl) {
  }

  clearValueProxy = () => this.clearValue.apply(this);

  ngOnInit(): void {

    let me = this.el.nativeElement as HTMLInputElement;

    if (me.nodeName.toUpperCase() !== 'INPUT') {
      throw new Error('Invalid input type for clearableInput:' + me);
    }

    let wrapper = this.renderer.createElement('span') as HTMLSpanElement;
    let clearIcon = this.renderer.createElement('i') as HTMLElement;
    clearIcon.id = 'clearIcon';

    // // calls the clearvalue function
    clearIcon.addEventListener('click', this.clearValueProxy);
    wrapper.setAttribute('style', 'margin-left: -20px;position: relative; margin-right:20px;');

    clearIcon.className = 'close';
    clearIcon.setAttribute('role', 'button');
    clearIcon.className = 'fa fa-times fa-1x';
    wrapper.appendChild(clearIcon);
    wrapper.id = 'clearSpan';

    me.insertAdjacentElement('afterend', wrapper);

  }

  clearValue() {
    if (this.control) {
      this.control.control.reset();
    } else {
      this.el.nativeElement.value = null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/directives/clear-input.directive.ts